import { createApp, compile, h } from 'vue';
import store from '$$globalStore';
import leftSideBar from '../../views/leftSideBar/leftSideBar.vue';
import header from '../../views/header/header.vue';
import footer from '../../views/footer/footer.vue';
import { initVgpVueComponents } from '../../vgpVueComponents';

webix.protoUI({
  name: 'vue',
  $init(config) {
    const vtm = config.template;
    const id = `vue_${webix.uid()}`;

    this.$vueData = config.data;

    delete config.data;
    config.template = `<div id='${id}'></div>`;

    // this.attachEvent('onAfterRender', function () {
    //   this.$vue = createApp({
    //     el: `#${id}`,
    //     data() {
    //       return this.$vueData;
    //     },
    //     render(createElement) {
    //       if (config.id === 'leftSideBar') {
    //         return createElement(leftSideBar);
    //       }
    //       if (config.id === 'header') {
    //         return createElement(header);
    //       }
    //       if (config.id === 'footer') {
    //         return createElement(footer);
    //       }

    //       return compile(vtm).render.call(this, createElement);
    //     },
    //     watch: this.config.watch,
    //   });

    //   this.$vue.use(store);
    // });

    this.attachEvent('onAfterRender', function () {
      this.$vue = createApp({
        data() {
          return { ...this.$vueData };
        },
        render() {
          if (config.id === 'leftSideBar') {
            return h(leftSideBar);
          }
          if (config.id === 'header') {
            return h(header);
          }
          if (config.id === 'footer') {
            return h(footer);
          }

          return compile(vtm).call(this);
        },
        watch: this.config.watch,
      });

      this.$vue.use(store);
      initVgpVueComponents(this.$vue);
      this.$vue.mount(`#${id}`);
    });
  },
  getVue() {
    return this.$vue;
  },
  setValues(value) {
    if (this.$vue) {
      for (const key in value) {
        if (typeof this.$vueData[key] !== 'undefined') this.$vue.$set(this.$vue.$data, key, value[key]);
      }
    } else this.$vueData = value;
  },
}, webix.ui.template);
